var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewOtherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.359 0.333862H12.0854C11.2359 0.333862 10.5472 1.02251 10.5472 1.872V7.14562C10.5472 7.99511 11.2359 8.68376 12.0854 8.68376H17.359C18.2085 8.68376 18.8971 7.99511 18.8971 7.14562V1.872C18.8971 1.02251 18.2085 0.333862 17.359 0.333862Z",
    fill: "#DA873E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8825 13.9685L15.8097 10.8957C15.5209 10.6079 15.1299 10.4463 14.7222 10.4463C14.3145 10.4463 13.9234 10.6079 13.6347 10.8957L10.5618 13.9685C10.2739 14.2572 10.1122 14.6483 10.1122 15.056C10.1122 15.4638 10.2739 15.8549 10.5618 16.1436L13.6347 19.2164C13.9233 19.5044 14.3144 19.6662 14.7222 19.6662C15.1299 19.6662 15.521 19.5044 15.8097 19.2164L18.8825 16.1436C19.1707 15.855 19.3325 15.4638 19.3325 15.056C19.3325 14.6482 19.1707 14.2571 18.8825 13.9685Z",
    fill: "#DA873E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81176 0.333862H1.53814C0.688648 0.333862 0 1.02251 0 1.872V7.14562C0 7.99511 0.688648 8.68376 1.53814 8.68376H6.81176C7.66125 8.68376 8.34989 7.99511 8.34989 7.14562V1.872C8.34989 1.02251 7.66125 0.333862 6.81176 0.333862Z",
    fill: "#DA873E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81176 10.8811H1.53814C0.688648 10.8811 0 11.5697 0 12.4192V17.6929C0 18.5423 0.688648 19.231 1.53814 19.231H6.81176C7.66125 19.231 8.34989 18.5423 8.34989 17.6929V12.4192C8.34989 11.5697 7.66125 10.8811 6.81176 10.8811Z",
    fill: "#DA873E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOtherIcon);
export default __webpack_public_path__ + "static/media/NewOtherIcon.d1fd1c2f4449817f406c803972b0fade.svg";
export { ForwardRef as ReactComponent };